module.exports = __webpack_public_path__ + "img/selected1-min.5ee1cb19.png";